import { Typography } from '@mui/material';
import { ErrorMessage, Loading } from 'components/CommonComponents';
import { COLOURS, PAD_LARGE_NUMBER } from 'providers/designSystem';
import { Flexbox } from 'components/Flexbox';
import { CopyableColourSwatch } from 'components/ColourSwatch/CopyableColourSwatch';

const ColourSwatches = ({ colours }) => {
    return (
        <Flexbox
            flexDirection="row"
            height="65vh"
            gap={PAD_LARGE_NUMBER}
            overflowY="scroll"
            padding={PAD_LARGE_NUMBER}
            border={`2px solid ${COLOURS.pink}`}
            // @ts-ignore
            borderRadius={[12, 0, 0, 12]}
        >
            {colours.length === 0 ? (
                <Typography variant="body1">No Colours</Typography>
            ) : (
                <>
                    {colours.map((colour, index) => {
                        return <CopyableColourSwatch key={colour.id} id={colour.id} colour={colour} size={'med'} />;
                    })}
                </>
            )}
        </Flexbox>
    );
};

export const Colours = ({ colours }) => {
    return (
        <div>
            {colours.loading && <Loading />}
            {colours.error && <ErrorMessage message="Something went wrong. Please refresh and try again" />}
            {colours.result && <ColourSwatches colours={colours.result} />}
        </div>
    );
};
